export const API_BASE = import.meta.env.VITE_API_BASE ?? '';

export interface ApiError extends Error {
  status: number;
  body: unknown;
}

export interface TenantRegistrationRequest {
  enterpriseName: string;
  email: string;
}

export interface CompleteTenantRegistrationRequest {
  token: string;
  password: string;
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  // Only send Content-Type: application/json when there's actually a body.
  // Fastify 5 rejects POSTs with content-type=application/json + empty body
  // (FST_ERR_CTP_EMPTY_JSON_BODY) — e.g., the test-connection action.
  const headers: Record<string, string> = { ...((init?.headers as Record<string, string>) ?? {}) };
  if (init?.body !== undefined && init.body !== null && headers['content-type'] === undefined) {
    headers['content-type'] = 'application/json';
  }
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...init,
    headers,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const apiMessage =
      typeof body === 'object' &&
      body !== null &&
      'message' in body &&
      typeof body.message === 'string'
        ? body.message
        : `API ${res.status}: ${res.statusText}`;
    const err = new Error(apiMessage) as ApiError;
    err.status = res.status;
    err.body = body;
    throw err;
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export function registerTenant(input: TenantRegistrationRequest): Promise<{ accepted: true }> {
  return apiFetch('/auth/register-tenant', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function completeTenantRegistration(
  input: CompleteTenantRegistrationRequest,
): Promise<{ ok: true }> {
  return apiFetch('/auth/complete-registration', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
